import { Sentry } from "../sentry";

const REQUEST_ID_KEY = "mgs.requestId";

export function getRequestId() {
  let requestId;

  try {
    requestId = sessionStorage.getItem(REQUEST_ID_KEY);
    if (!requestId) {
      requestId = crypto.randomUUID();
      sessionStorage.setItem(REQUEST_ID_KEY, requestId);
    }
  } catch (_) {
    requestId = crypto.randomUUID();
  }

  try {
    Sentry.getCurrentScope()?.setTag("requestId", requestId);
  } catch (_) {
    /* ignore */
  }

  return requestId;
}
